



import Vue from 'vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import TileLayer from 'ol/layer/Tile'
import Map from 'ol/Map'
import View from 'ol/View'
import OSM from 'ol/source/OSM'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Icon from 'ol/style/Icon'
import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import Circle from 'ol/style/Circle'
import { fromLonLat } from 'ol/proj'
import {
    INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI,
    INTERVENTO_FITOSANITARIO_MICOSI,
    COLOR_PIANTA_POTATA,
    COLOR_PIANTA_DA_POTARE,
    COLOR_PIANTA_CON_DANNI_DA_INSETTO,
    COLOR_PIANTA_CON_DANNI_DA_INSETTO_FIXED,
    COLOR_PIANTA_CON_MICOSI,
    COLOR_PIANTA_CON_MICOSI_FIXED,
    OPEN_LAYER_GEOJSON_FORMAT
} from '@/costanti'
// Costanti per la configurazione
const coordinateIniziali = [11.273, 44.477]
const zoomIniziale = 18
const PALLINO_ICONA_RADIUS = 2
const PALLINO_ICONA_WIDTH = 4
const createStyleOverlayer = (color) => (new Style({
    image: new Circle({
        radius: PALLINO_ICONA_RADIUS,
        stroke: new Stroke({
            color: color,
            width: PALLINO_ICONA_WIDTH
        })
    })
}))
const styleCacheOverlayers = {
    piantaPotata: createStyleOverlayer(COLOR_PIANTA_POTATA),
    piantaDaPotare: createStyleOverlayer(COLOR_PIANTA_DA_POTARE),
    piantaConDanniDaInsetto: createStyleOverlayer(COLOR_PIANTA_CON_DANNI_DA_INSETTO),
    piantaConDanniDaInsettoFixed: createStyleOverlayer(COLOR_PIANTA_CON_DANNI_DA_INSETTO_FIXED),
    piantaConMicosi: createStyleOverlayer(COLOR_PIANTA_CON_MICOSI),
    piantaConMicosiFixed: createStyleOverlayer(COLOR_PIANTA_CON_MICOSI_FIXED)
}
export default Vue.extend({
    data: () => ({
        map: null,
        vectorLayerRilevamenti: null,
        vectorLayerPianteDaPotare: null,
        vectorLayerPianteConDanniDaInsetto: null,
        vectorLayerPianteConMicosi: null,
        vectorLayerPuntiDiInteresse: null,
        // a javascript object literal can be used to cache
        // previously created styles. Its very important for
        // performance to cache styles.
        styleCache: {}

    }),
    computed: {
        ...mapGetters('mapplantsMappa', ['rilevamentiGeojson', 'pianteDaPotareGeojson', 'pianteConDanniDaInsettoGeojson', 'pianteConMicosiGeojson']),
        ...mapGetters('mapplantsPuntiDiInteresse', ['puntiDiInteresseGeojson']),
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapState('mapplantsFiltriCensimento', [
            'idRilevamento',
            'idTag',
            'giudizioRadiciColletto',
            'giudizioFustoBranche',
            'giudizioRamiChioma',
            'contesto',
            'interventiFitosanitari',
            'potatura',
            'monitoraggio'
        ]),
        ...mapState('modal', ['nuoveCoordinate'])
    },
    watch: {
        // quando i rilevameti vengono caricati
        rilevamentiGeojson(newValue) {
            // togliamo i rilevamenti precedenti
            this.vectorLayerRilevamenti.getSource().clear()
            // leggiamo i rilevamenti
            this.vectorLayerRilevamenti.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
        },
        pianteDaPotareGeojson(newValue) {
            // togliamo i rilevamenti precedenti
            this.vectorLayerPianteDaPotare.getSource().clear()
            // leggiamo i rilevamenti
            this.vectorLayerPianteDaPotare.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
        },
        pianteConDanniDaInsettoGeojson(newValue) {
            // togliamo i rilevamenti precedenti
            this.vectorLayerPianteConDanniDaInsetto.getSource().clear()
            // leggiamo i rilevamenti
            this.vectorLayerPianteConDanniDaInsetto.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
        },
        pianteConMicosiGeojson(newValue) {
            // togliamo i rilevamenti precedenti
            this.vectorLayerPianteConMicosi.getSource().clear()
            // leggiamo i rilevamenti
            this.vectorLayerPianteConMicosi.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
        },
        puntiDiInteresseGeojson(newValue) {
            if (this.vectorLayerPuntiDiInteresse !== null) {
                // togliamo il source precedente
                this.vectorLayerPuntiDiInteresse.getSource().clear()
                // leggiamo la nuova fonte
                this.vectorLayerPuntiDiInteresse.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
            }
        },
        // === aggiorniamo i rilevamenti quando cambiano i filtri ===
        idRilevamento(newValue) {
            this.caricaRilevamenti()
        },
        idTag(newValue) {
            this.caricaRilevamenti()
        },
        giudizioRadiciColletto(newValue) {
            this.caricaRilevamenti()
        },
        giudizioFustoBranche(newValue) {
            this.caricaRilevamenti()
        },
        giudizioRamiChioma(newValue) {
            this.caricaRilevamenti()
        },
        contesto(newValue) {
            this.caricaRilevamenti()
        },
        interventiFitosanitari(newValue) {
            // remove the layers
            this.map.removeLayer(this.vectorLayerPianteConDanniDaInsetto)
            this.map.removeLayer(this.vectorLayerPianteConMicosi)
            // choose which to add
            if (newValue.findIndex(item => item === INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI) > -1) this.map.addLayer(this.vectorLayerPianteConDanniDaInsetto)
            if (newValue.findIndex(item => item === INTERVENTO_FITOSANITARIO_MICOSI) > -1) this.map.addLayer(this.vectorLayerPianteConMicosi)
        },
        potatura(newValue) {
            if (newValue)
                this.map.addLayer(this.vectorLayerPianteDaPotare)
            else
                this.map.removeLayer(this.vectorLayerPianteDaPotare)
        },
        monitoraggio(newValue) {
            this.caricaRilevamenti()
        },
        // quando cambia l'indirizzo autocompletato, abbiamo nuove coordinate in cui andare
        nuoveCoordinate(newValue) {
            // se abbiamo le coordinate
            // ci spostiamo con un'animazione
            this.map.getView().animate({
                center: fromLonLat(newValue),
                zoom: 18,
                duration: 1000
            })
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('mapplantsMappa', ['caricaRilevamenti', 'cambiaRilevamentoMostrato'])
    },
    mounted() {
        // caichiamo i vettori layer
        this.vectorLayerRilevamenti = new VectorLayer({
            source: new VectorSource({
                features: undefined
            }),
            style: (feature: any, resolution) => {
                const tipoPianta = feature.get('tipoPianta')
                // check the cache and create a new style
                // level if its not been created before.
                if (!this.styleCache[tipoPianta]) {
                    let src = '/mapplants/albero_tr.png'
                    switch (tipoPianta) {
                        case 'Grande':
                            src = '/mapplants/albero_tr_scuro.png'
                            break
                        case 'Media':
                            src = '/mapplants/albero_tr.png'
                            break
                        case 'Piccola':
                            src = '/mapplants/albero_tr_chiaro.png'
                            break
                        case 'Arbusto':
                            src = '/mapplants/icona_arbusto.png'
                            break
                    }

                    this.styleCache[tipoPianta] = new Style({
                        image: new Icon(({
                            // anchor: [0.5, 0.5],
                            scale: .15,
                            src: src
                        }))
                    })
                }
                // at this point, the style for the current level is in the cache
                // so return it (as an array!)
                return [this.styleCache[tipoPianta]]
            }
        })

        this.vectorLayerPianteDaPotare = new VectorLayer({
            source: new VectorSource({}),
            style: (feature: any, resolution) => (
                feature.get('wasCut') ? styleCacheOverlayers.piantaPotata : styleCacheOverlayers.piantaDaPotare
            )
        })
        this.vectorLayerPianteConDanniDaInsetto = new VectorLayer({
            source: new VectorSource({}),
            style: (feature: any, resolution) => (
                feature.get('wasFixed') ? styleCacheOverlayers.piantaConDanniDaInsettoFixed : styleCacheOverlayers.piantaConDanniDaInsetto
            )
        })
        this.vectorLayerPianteConMicosi = new VectorLayer({
            source: new VectorSource({}),
            style: (feature: any, resolution) => (
                feature.get('wasFixed') ? styleCacheOverlayers.piantaConMicosiFixed : styleCacheOverlayers.piantaConMicosi
            )
        })
        // carichiamo la mappa
        this.map = new Map({
            target: 'map',
            controls: [],
            layers: [
                // open street map
                new TileLayer({
                    source: new OSM()
                })
            ],
            // ci posizioniamo su casteldelci
            view: new View({
                center: fromLonLat([coordinateIniziali[0], coordinateIniziali[1]]),
                zoom: zoomIniziale
            })
        })

        // aggiugiamo il rilevamento alla mappa
        this.map.addLayer(this.vectorLayerRilevamenti)
        // mostriamo gli info point solo agli utenti non loggati
        if (!this.isAuthenticated) {
            this.vectorLayerPuntiDiInteresse = new VectorLayer({
                source: new VectorSource({}),
                style: new Style({
                    image: new Icon(({
                        scale: .25,
                        src: '/mapplants/icona_info.png'
                    }))
                })
            })
            // sopra gli altri pallini
            this.vectorLayerPuntiDiInteresse.setZIndex(1)
            this.map.addLayer(this.vectorLayerPuntiDiInteresse)
        }

        // display popup on click
        this.map.on('click', (evt: any) => {
            // il rilevamento cliccato
            const feature = this.map.forEachFeatureAtPixel(evt.pixel, (featureAtPixel: any, layer: any) => featureAtPixel)
            // se effettivamente abbiamo cliccato un rilevamento
            if (feature) {
                const id = feature.get('id')
                const link = feature.get('link')
                if (link) {
                    window.open(link, null)
                } else if (id) {
                    // mostriamo il rilevamento
                    this.showModal('mapplants-rilevamento-info')
                    this.cambiaRilevamentoMostrato(id)
                }
            } else {
                // se abbiamo cliccato semplicemente sulla mappa
            }
        })

        // BUG fix
        // senza questo scazza e schiaccia la mappa all inizio
        setTimeout(() => {
            this.map.updateSize()
        }, 200)
    }
})
